import React, { SetStateAction } from "react";
import { ButtonBase } from "@reusejs/react";
import { XIcon } from "@heroicons/react/solid";

interface PDFViewerInterface {
  remark: string;
  setModal: React.Dispatch<SetStateAction<boolean>>;
  setRemark: React.Dispatch<SetStateAction<string>>;
  bidderData: any;
  callback: (e: any) => void;
}

const RemarkModal: React.FC<PDFViewerInterface> = ({
  setModal,
  remark,
  setRemark,
  callback,
  bidderData,
}) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
      <div className="relative bg-white shadow-lg rounded-lg max-w-lg w-full">
        <h1 className="text-xl font-medium not-italic leading-6 text-gray-500 text-center w-full p-4 bg-blue-100 border-b border-gray-500">
          Add Remarks
        </h1>
        <div className="absolute top-4 right-4">
          <div
            className="cursor-pointer bg-gray-50 rounded-full p-1 border text-gray-900"
            onClick={() => setModal(false)}
          >
            <XIcon className="h-4 w-4" aria-hidden="true" />
          </div>
        </div>
        <div className="p-4">
          <textarea
            name="remark"
            rows={5}
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            className="w-full border-gray-300 rounded-lg p-2"
            placeholder="Enter your remark here..."
          ></textarea>
          <div className="flex justify-end space-x-3 mt-4">
            <ButtonBase
              buttonBaseClasses={{
                backgroundColor: "bg-white",
                border: "border border-blue-500 hover:border-blue-700",
                textColor: "text-blue-500 hover:text-blue-700",
              }}
              type="submit"
              label={"cancel"}
              onClick={() => setModal(false)}
            />
            <ButtonBase
              buttonBaseClasses={{ backgroundColor: "" }}
              type="submit"
              label={"Submit"}
              onClick={() => {
                callback(bidderData);
                setModal(false);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemarkModal;
